const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

let cachedFeatureFlags = null;
let cacheTimestamp = null;
const CACHE_DURATION = 60000; // 1 minute

/**
 * Fetch feature flags from the backend
 * @returns {Promise<Object>} Feature flags object
 */
export const fetchFeatureFlags = async () => {
  // Return cached value if still valid
  if (cachedFeatureFlags && cacheTimestamp && (Date.now() - cacheTimestamp < CACHE_DURATION)) {
    return cachedFeatureFlags;
  }

  try {
    const response = await fetch(`${API_URL}/feature-flags`);
    const data = await response.json();

    if (data.success && data.features) {
      cachedFeatureFlags = data.features;
      cacheTimestamp = Date.now();
      return data.features;
    }

    // Default to disabled if API fails
    return {
      whatsappVerification: false
    };
  } catch (error) {
    console.error('Error fetching feature flags:', error);
    // Default to disabled if API fails
    return {
      whatsappVerification: false
    };
  }
};

/**
 * Check if WhatsApp verification is enabled
 * @returns {Promise<boolean>}
 */
export const isWhatsAppVerificationEnabled = async () => {
  const features = await fetchFeatureFlags();
  return features.whatsappVerification === true;
};

/**
 * Clear the feature flags cache
 */
export const clearFeatureFlagsCache = () => {
  cachedFeatureFlags = null;
  cacheTimestamp = null;
};
